module.exports = __webpack_public_path__ + "img/blue_logo.187b9c2.svg";